
namespace GeniuzPOS.AdvPromo {
    import fld = Adv05ItemDetailRow.Fields;
    @Serenity.Decorators.registerClass()
    export class Adv05ItemDetailGrid extends Serenity.EntityGrid<Adv05ItemDetailRow, any> {
        
        protected getColumnsKey() { return Adv05ItemDetailColumns.columnsKey; }
        protected getDialogType() { return Adv05ItemDetailDialog; }
        protected getIdProperty() { return Adv05ItemDetailRow.idProperty; }
        protected getInsertPermission() { return Adv05ItemDetailRow.insertPermission; }
        protected getLocalTextPrefix() { return Adv05ItemDetailRow.localTextPrefix; }
        protected getService() { return Adv05ItemDetailService.baseUrl; }

     
        private _areas: string[] = []
        private _PmGroupId: string
        private _PmType: string
        private _PmTypes: number
        private _PmId: string
        private _PluCode: string
        private _SkuCode: string
        private _StyleId: string
        private _Brand: string
        private _Supplier: string
        private _Cate: string
        private _Cate2: string
        private _Cate3: string

        constructor(container: JQuery) {
            super(container);
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 1000;
            return opt;
        }

        // protected createView(): Slick.RemoteView<TEntity> {
        //     let view = super.createView();
        //     (view as any).onDataLoaded.subscribe((e, ui) => {
        //         Q.notifyInfo('data loaded');
        //     });
        //     return view;
        // }//สำหรับขึ้น ว่าโหลดข้อมูลสำเร็จ

        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: Adv05ItemDetailService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );

            return buttons;
        }
        protected createQuickSearchInput() {
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

     
                filters.push({
                    field: 'EndPromoDate',
                    type: Serenity.DateEditor,
                    title: 'กำหนดวันที่แสดงโปร',
                    handler: h => {
                        if (h.active && h.value) {
                            h.request.Criteria = Serenity.Criteria.and(h.request.Criteria,
                                [['EndPromoDate'], '>=', h.value],
                                [['StartPromoDate'], '<=', h.value]
                            );
                        }
                    },
                    init: w => {
                        (w as Serenity.DateEditor).valueAsDate = new Date();
                    }
                });
      

        // var h = Q.tryFirst(PsAdvPromoHdAppRow.getLookup().items, x => x.PromoApproveFg == 1 && new Date(x.EndPromoDate) >= new Date())
        //     if(h == null){
        //         h = Q.tryFirst(PsAdvPromoHdAppRow.getLookup().items, x => x.PromoApproveFg == 1)
        //     }
        // Q.first(filters, x => x.field == "PmGroupId").init = w => {
        //     let stringEditor = w as Serenity.StringEditor;
        //     stringEditor.value = h.PmGroupId;
        //     // stringEditor.changeSelect2(e => {

        //     //     // this._PmGroupId =stringEditor.value ?? this._PmGroupId ;
        //     //     // if (Q.isEmptyOrNull(stringEditor.value)) {
        //     //     //     Q.notifyError("PmGroupId cannot be null.");
        //     //     //     stringEditor.value = this._PmGroupId ;
        //     //     // }
        //     // });
          
        // };

        // var d = Q.tryFirst(Adv05ItemDetailRow.getLookup().items, x => x.PmGroupId == h.PmGroupId  )
      
        // if(d != null){
        //     Q.first(filters, x => x.field == "PmType").init = w => {
        //         let stringEditor = w as Serenity.IntegerEditor;
        //         stringEditor.value = d.PmType;
        //         stringEditor.changeSelect2(e => {
    
        //             // this._PmTypes =stringEditor.value ?? this._PmTypes ;
        //             // if (Q.isEmptyOrNull(stringEditor.value.toString())) {
        //             //     Q.notifyError("PmType cannot be null.");
        //             //     stringEditor.value = this._PmTypes ;
        //             // }
        //         });
              
        //     };

        // Q.first(filters, x => x.field == "PmId").init = w => {
        //     (w as Serenity.StringEditor).value = d.PmId;
        // };}
    

       

        // const PmIdFilter = Q.tryFirst(filters, x => x.field == "PmId")
        // if (PmIdFilter) {
        //     PmIdFilter.handler = h => {
        //         const el = h.widget.element.parent()[0];
        //         if (el.classList.contains('d-none')) {
        //             return;
        //         }

        //         this._PmId = h.value
        //         h.request = this.updateListRequest(h.request)
        //         h.active = !Q.isEmptyOrNull(this._PmId)
        //     }
        // }

        // const PmGroupIdFilter = Q.tryFirst(filters, x => x.field == "PmGroupId")
        // if (PmGroupIdFilter) {
        //     PmGroupIdFilter.handler = h => {
        //         const el = h.widget.element.parent()[0];
        //         if (el.classList.contains('d-none')) {
        //             return;
        //         }

        //         this._PmGroupId = h.value
        //         h.request = this.updateListRequest(h.request)
        //         h.active = !Q.isEmptyOrNull(this._PmGroupId)
        //     }
        // }

        // const PmTypeFilter = Q.tryFirst(filters, x => x.field == "PmType")
        // if (PmTypeFilter) {
        //     PmTypeFilter.handler = h => {
        //         const el = h.widget.element.parent()[0];
        //         if (el.classList.contains('d-none')) {
        //             return;
        //         }

        //         this._PmType = h.value
        //         h.request = this.updateListRequest(h.request)
        //         h.active = !Q.isEmptyOrNull(this._PmType)
        //     }
        // }

        // const SupplCodeFilter = Q.tryFirst(filters, x => x.field == "SupplCode")
        // if (SupplCodeFilter) {
        //     SupplCodeFilter.handler = h => {
        //         const el = h.widget.element.parent()[0];
        //         if (el.classList.contains('d-none')) {
        //             return;
        //         }

        //         this._Supplier = h.value
        //         h.request = this.updateListRequest(h.request)
        //         h.active = !Q.isEmptyOrNull(this._Supplier)
        //     }
        // }

        // const SkuCodeFilter = Q.tryFirst(filters, x => x.field == "SkuCode")
        // if (SkuCodeFilter) {
        //     SkuCodeFilter.handler = h => {
        //         const el = h.widget.element.parent()[0];
        //         if (el.classList.contains('d-none')) {
        //             return;
        //         }

        //         this._SkuCode = h.value
        //         h.request = this.updateListRequest(h.request)
        //         h.active = !Q.isEmptyOrNull(this._SkuCode)
        //     }
        // }

        // const PluCodeFilter = Q.tryFirst(filters, x => x.field == "PluCode")
        // if (PluCodeFilter) {
        //     PluCodeFilter.handler = h => {
        //         const el = h.widget.element.parent()[0];
        //         if (el.classList.contains('d-none')) {
        //             return;
        //         }

        //         this._PluCode = h.value
        //         h.request = this.updateListRequest(h.request)
        //         h.active = !Q.isEmptyOrNull(this._PluCode)
        //     }
        // }

        // const BrandCodeFilter = Q.tryFirst(filters, x => x.field == "BrandCode")
        // if (BrandCodeFilter) {
        //     BrandCodeFilter.handler = h => {
        //         const el = h.widget.element.parent()[0];
        //         if (el.classList.contains('d-none')) {
        //             return;
        //         }

        //         this._Brand = h.value
        //         h.request = this.updateListRequest(h.request)
        //         h.active = !Q.isEmptyOrNull(this._Brand)
        //     }
        // }

        // const StyleIdFilter = Q.tryFirst(filters, x => x.field == "StyleId")
        // if (StyleIdFilter) {
        //     StyleIdFilter.handler = h => {
        //         const el = h.widget.element.parent()[0];
        //         if (el.classList.contains('d-none')) {
        //             return;
        //         }

        //         this._StyleId = h.value
        //         h.request = this.updateListRequest(h.request)
        //         h.active = !Q.isEmptyOrNull(this._StyleId)
        //     }
        // }
        // const CatCodeFilter = Q.tryFirst(filters, x => x.field == "CatCode")
        // if (CatCodeFilter) {
        //     CatCodeFilter.handler = h => {
        //         const el = h.widget.element.parent()[0];
        //         if (el.classList.contains('d-none')) {
        //             return;
        //         }

        //         this._Cate = h.value
        //         h.request = this.updateListRequest(h.request)
        //         h.active = !Q.isEmptyOrNull(this._Cate)
        //     }
        // }
        // const SubCat1CodeFilter = Q.tryFirst(filters, x => x.field == "SubCat1Code")
        // if (SubCat1CodeFilter) {
        //     SubCat1CodeFilter.handler = h => {
        //         const el = h.widget.element.parent()[0];
        //         if (el.classList.contains('d-none')) {
        //             return;
        //         }

        //         this._Cate2 = h.value
        //         h.request = this.updateListRequest(h.request)
        //         h.active = !Q.isEmptyOrNull(this._Cate2)
        //     }
        // }
        // const SubCat2CodeFilter = Q.tryFirst(filters, x => x.field == "SubCat2Code")
        // if (SubCat2CodeFilter) {
        //     SubCat2CodeFilter.handler = h => {
        //         const el = h.widget.element.parent()[0];
        //         if (el.classList.contains('d-none')) {
        //             return;
        //         }

        //         this._Cate3 = h.value
        //         h.request = this.updateListRequest(h.request)
        //         h.active = !Q.isEmptyOrNull(this._Cate3)
        //     }
        // }




            return filters;
        }


        private updateListRequest(req: AdvPromoDetailRequest): AdvPromoDetailRequest {
            req.PmId = this._PmId ?? "";
            req.PmGroupId = this._PmGroupId ?? "";
            req.PmType = this._PmType ?? "";
            req.PluCode = this._PluCode ?? "";
            req.SkuCode = this._SkuCode ?? "";
            req.BrandCode = this._Brand ?? "";
            req.SupplCode = this._Supplier ?? "";
            req.StyleId = this._StyleId ?? "";
            req.CatCode = this._Cate ?? "";
            req.SubCat1Code = this._Cate2 ?? "";
            req.SubCat2Code = this._Cate3 ?? "";

            // if (this._PmId) {
            //     req._PmId = this._PmId
               
            // } else {
            //     if (this._areas.length) {
            //         req.AreaCode = this._areas.join(',')
            //         req.SelectedArea = ''
            //     }
            // }
            // if (this._PmGroupId) {
            //     req.BranchCode = this._selectedBranch
            // } else {
            //     // if (this._branch) {
            //     //     req.BranchCode = this._branch
            //     // } else if (this._selectedArea || this._areas.length) {
            //     //     req.BranchCode = '*';
            //     // }
            // }
            // // req.FromDate = this._fromDate
            // // req.ToDate = this._toDate
            // // req.Options = getCustomerTypeViewOptions(this._retail, this._staff, this._wholesale, this._vip)
            // // req.AreaCount = this._areas.length
    
            return req;
        }
    }
}